export const MEMBERSHIP_USERDEFINEDFIELDS_LOADING = 'REDUX_SAGA_MEMBERSHIP_USERDEFINEDFIELDS_LOADING';
export const MEMBERSHIP_USERDEFINEDFIELDS_DATA_SUCCESS = 'REDUX_SAGA_MEMBERSHIP_USERDEFINEDFIELDS_DATA_SUCCESS';
export const MEMBERSHIP_USERDEFINEDFIELDS_RESET = "REDUX_SAGA_MEMBERSHIP_USERDEFINEDFIELDS_RESET";
export const MEMBERSHIP_USERDEFINEDFIELDS_DATA_ERROR = 'REDUX_SAGA_MEMBERSHIP_USERDEFINEDFIELDS_DATA_ERROR';
export const UPDATE_MEMBER_USERDEFINEDFIELD = 'REDUX_SAGA_UPDATE_MEMBER_USERDEFINEDFIELD';
export const UPDATE_MEMBERSHIP_USERDEFINEDFIELD_RENEW = 'REDUX_SAGA_UPDATE_MEMBERSHIP_USERDEFINEDFIELD_RENEW';
export const UPDATE_USERDEFINEDFIELDS_MEMBER_ONEDIT_WHEN_CLICK_CANCEL_BUTTON = 'REDUX_SAGA_UPDATE_USERDEFINEDFIELDS_MEMBER_ONEDIT_WHEN_CLICK_CANCEL_BUTTON';
export const UPDATE_USERDEFINEDFIELDS_MEMBER_ON_SAVE = 'REDUX_SAGA_UPDATE_USERDEFINEDFIELDS_MEMBER_ON_SAVE';


export const actionGetMembershipUserDefinedFields = (dispatch, type, id, listOfIds) => {
    dispatch({ type: MEMBERSHIP_USERDEFINEDFIELDS_LOADING, payload: { type: type, id: id, listOfIds: listOfIds } })
};

export const actionUpdateMemberUDF = (dispatch, membershipTypeID, userNo, categoryName, udfID, value, isEdit) => {
    dispatch({
        type: UPDATE_MEMBER_USERDEFINEDFIELD, payload:
            { membershipTypeID: membershipTypeID, userNo: userNo, categoryName: categoryName, udfID: udfID, value: value, isEdit: isEdit }
    })
};

export const actionResetMembershipUDFs = (dispatch) => {
    dispatch({ type: MEMBERSHIP_USERDEFINEDFIELDS_RESET });
}

export const actionUpdateMembershipUdfsWithCustomerUdfsValues = (dispatch, membershipPackage, customerUdfs) => {
    dispatch({ type: UPDATE_MEMBERSHIP_USERDEFINEDFIELD_RENEW, payload: { membershipPackage: membershipPackage, customerUdfs: customerUdfs } })
};


export const actionUpdateUdfsOnEditCancel = (dispatch, membershipTypeID, userNo, isEdit) => {
    dispatch({
        type: UPDATE_USERDEFINEDFIELDS_MEMBER_ONEDIT_WHEN_CLICK_CANCEL_BUTTON,
        payload: { membershipTypeID: membershipTypeID, userNo: userNo, isEdit: isEdit }
    })
};

export const actionUpdateMemberTypeUDfsOnSave = (dispatch, membershipTypeID, userNo) => {
    dispatch({
        type: UPDATE_USERDEFINEDFIELDS_MEMBER_ON_SAVE,
        payload: { membershipTypeID: membershipTypeID, userNo: userNo }
    })
};


